import React, { useState } from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// nodejs library that concatenates classes
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { TextField } from '@mui/material';

const useStyles = makeStyles(theme => ({
  labelRootError: {
    color: 'red !important',
  },
}));

export default function CustomInput(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    helperText,
    textfieldProps,
  } = props;

  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
    [classes.whiteUnderline]: white,
  });
  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
  });
  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });
  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(formControlProps.className, classes.formControl);
  } else {
    formControlClasses = classes.formControl;
  }
  var helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });

  // eslint-disable-next-line no-unused-vars
  const [value, setValue] = useState(inputProps.value || inputProps.defaultValue);

  // When used with datepicker, it use inputReft, so the setValue is not called
  // using the real value fix the datepicker
  //const currentValue = value || inputProps.value || inputProps.defaultValue;

  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      <TextField
        label={labelText}
        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 0 } }}
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses,
        }}
        InputLabelProps={labelProps}
        InputProps={inputProps}
        id={id}
        error={error}
        onChange={e => {
          if (inputProps.onChange) {
            inputProps.onChange(e);
          }
          setValue(e.target.value);
        }}
        onKeyDown={e => {
          if (inputProps.onKeyDown) {
            inputProps.onKeyDown(e);
          }
        }}
        {...textfieldProps}
      />
      {helperText && (
        <FormHelperText id={id + '-text'} className={helpTextClasses}>
          {helperText}
        </FormHelperText>
      )}

      {error && (
        <FormHelperText id={id + '-error'} className={helpTextClasses}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.string,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helperText: PropTypes.node,
};
